import { DeepPartial, RxTemplate } from './rx-template.model';

export const glidewellTemplate: DeepPartial<RxTemplate> = {
	templateId: 'glidewell',
	ui: {
		order: {
			items: {
				sendToChange: { requiresConfirmationForReset: true }
			}
		},
		teethDiagram: {
			items: {
				toothEditorProperties: { hidden: true }
			}
		},
		scanOptions: {
			items: {
				multiBite: { disabled: true }
			}
		}
	},
	behaviors: {
		validation: {
			items: {
				crownSection: { disabled: true },
				scanBody: { disabled: true }
			}
		}
	}
};
